import lockupUrl from '../assets/brand/logo-lockup.png'
import markUrl from '../assets/brand/logo-mark.png'
import { cn } from '../lib/utils'

/**
 * The logo assumes a white page. The wedge between the blue and the orange is
 * transparent rather than white, and it opens out past the blue's apex, so it
 * cannot be filled to make a reversed variant -- on the dark sidebar the wedge
 * would simply fill with navy.
 *
 * Hence the white plate. Against the light surfaces it is invisible, since they
 * are white already; against the sidebar and dark mode it reads as a deliberate
 * chip. One treatment, so the logo looks the same everywhere it appears.
 *
 * Both components size from the caller's box: pass `size-6`, `h-8`, etc.
 * Regenerate the assets with logos/build_brand_assets.py.
 */

type BrandProps = {
  className?: string
  /** Leave empty where adjacent text already names the brand. */
  alt?: string
}

export function BrandMark({ className, alt = '' }: BrandProps) {
  return (
    <span
      className={cn('grid shrink-0 place-items-center rounded bg-white', className)}
    >
      <img src={markUrl} alt={alt} className="h-[72%] w-auto" />
    </span>
  )
}

export function BrandLockup({ className, alt = 'Logic Planet' }: BrandProps) {
  return (
    <span className={cn('inline-flex shrink-0 rounded bg-white px-2 py-1.5', className)}>
      <img src={lockupUrl} alt={alt} className="h-full w-auto" />
    </span>
  )
}
